import styled from 'styled-components';
import { OnPrimary,ShadowColor,DividerColor } from '../../Colors';
import CreateQuizPreview from '../../molecules/CreateQuizPreview';
import {QuizDemoPresenter} from '../../molecules/Editor';

const defaulStyle = {
	Wrapper : styled.div`
        padding-left : 3rem;
        padding-right : 3rem;
        display : flex;
        justify-content : center;
    `,
	Divider : styled.div`
        margin : 0 2rem;
        border-left : 1px dotted ${DividerColor};
    `,
	CreateQuizPreview : styled(CreateQuizPreview).attrs({blankColor:'transparent'})`
        background-color : transparent;
        padding : 1rem;
        flex: 1;
        box-shadow: 0px 8px 16px 0px ${ShadowColor};
        border-radius : 5px;
        color : ${OnPrimary};
    `,
	QuizDemoPresenter : styled(QuizDemoPresenter)`
        flex : 1;
        
    `
};

const mobileStyle = {
	Wrapper : styled.div`
    `,
	DemoWrapper : styled.div`
        padding : 0 1rem;
    `,
};

export default defaulStyle;
export {mobileStyle};